import React from 'react';
import {
  Table, Button, Progress, Card, Row, Col, Tag,
} from 'antd';
import { connect } from 'react-redux';
import * as userActions from '../../actions/user-action-types';
import DashBoard from '../dashboard/Dashboard';

class PreRegistration extends React.PureComponent {
  componentDidMount() {
    const { fetchPreregStats } = this.props;
    fetchPreregStats();
  }

  handleExport = () => {
    const { exportLandingUsers } = this.props;
    exportLandingUsers({ format: 'csv' });
  }

  render() {
    const { preregStats } = this.props;
    // camelCase: parkao-api's sendRes camel-cases every response key
    // (utilities/common.js, utilities/snakeCase.js keysToCamel).
    const stats = preregStats || {};
    const target = stats.target || 500;
    const totalSpots = stats.totalLandingSpots || 0;
    const progressPct = stats.progressPercentage || 0;
    const recentRegistrations = stats.registrationsByDay || [];

    const registrationColumns = [
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
      },
      {
        title: 'Registrations',
        dataIndex: 'count',
        key: 'count',
      },
    ];

    return (
      <DashBoard selectKey="pre_registration" {...this.props}>
        <div className="tableHeaderText">
          <div className="tableMainHead">
            <p className="titleTextStyle">Pre-Registration Dashboard</p>
          </div>
          <div>
            <Button type="primary" onClick={this.handleExport}>
              Export Landing Users (CSV)
            </Button>
          </div>
        </div>
        <br />

        {/* Progress Bar */}
        <Card style={{ marginBottom: 24 }}>
          <h3 style={{ marginBottom: 16 }}>Launch Progress</h3>
          <Progress
            percent={Math.min(Math.round(progressPct), 100)}
            status={progressPct >= 100 ? 'success' : 'active'}
            format={() => `${totalSpots} / ${target} parkings`}
          />
          {stats.lastRegistration && (
            <p style={{ marginTop: 8, color: '#888' }}>
              Last registration: {new Date(stats.lastRegistration).toLocaleString()}
            </p>
          )}
        </Card>

        {/* Stats Cards */}
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={6}>
            <Card>
              <h4>Landing Users</h4>
              <p style={{ fontSize: 28, fontWeight: 'bold', margin: 0 }}>
                {stats.totalLandingUsers || 0}
              </p>
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <h4>Verified Users</h4>
              <p style={{ fontSize: 28, fontWeight: 'bold', margin: 0 }}>
                {stats.totalVerifiedUsers || 0}
              </p>
              <Tag color="green">
                {stats.totalLandingUsers
                  ? Math.round((stats.totalVerifiedUsers / stats.totalLandingUsers) * 100)
                  : 0}% verified
              </Tag>
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <h4>Landing Spots</h4>
              <p style={{ fontSize: 28, fontWeight: 'bold', margin: 0 }}>
                {stats.totalLandingSpots || 0}
              </p>
            </Card>
          </Col>
          <Col span={6}>
            <Card>
              <h4>Spots with Photos</h4>
              <p style={{ fontSize: 28, fontWeight: 'bold', margin: 0 }}>
                {stats.spotsWithPhotos || 0}
              </p>
              <Tag color="blue">
                {stats.totalLandingSpots
                  ? Math.round((stats.spotsWithPhotos / stats.totalLandingSpots) * 100)
                  : 0}% with photos
              </Tag>
            </Card>
          </Col>
        </Row>

        {/* Recent Registrations Table */}
        <Card>
          <h3 style={{ marginBottom: 16 }}>Recent Registrations (Last 30 Days)</h3>
          <Table
            columns={registrationColumns}
            dataSource={recentRegistrations.map((r, i) => ({ ...r, key: i }))}
            pagination={false}
            size="small"
          />
        </Card>
      </DashBoard>
    );
  }
}

const mapStateToProps = ({
  user: {
    preregStatsStatus,
    preregStats,
  },
}) => ({
  preregStatsStatus,
  preregStats,
});

const mapDispatchToProps = {
  fetchPreregStats: userActions.fetchPreregStats,
  exportLandingUsers: userActions.exportLandingUsers,
};

export default connect(mapStateToProps, mapDispatchToProps)(PreRegistration);
